import { render, staticRenderFns } from "./DiscountCodesList.vue?vue&type=template&id=06077842&scoped=true"
import script from "./DiscountCodesList.vue?vue&type=script&lang=js"
export * from "./DiscountCodesList.vue?vue&type=script&lang=js"
import style0 from "./DiscountCodesList.vue?vue&type=style&index=0&id=06077842&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06077842",
  null
  
)

export default component.exports